import { DefaultDatasetDurationLimiter } from "@/services/license/license-limiters/dataset-duration-limiters/default-dataset-duration-limiter";
import { getUserUniqueConvertDatasetDurationLimit } from "@/actions/db/user-unique-dataset-limits";

export class ConvertDatasetDurationLimiter extends DefaultDatasetDurationLimiter {
  getUniqueLimit(userId: string): Promise<number | null> {
    return getUserUniqueConvertDatasetDurationLimit(userId);
  }
}
